export interface WorkingHoursProps {
  day: string;
  hours: string;
}

export function WorkingHours(props: WorkingHoursProps) {
  const { day, hours } = props;
  return (
    <div className="grid grid-cols-[50px_1fr]">
      <span className="text-sm uppercase text-primary-white leading-[19.2px]">
        {day}:
      </span>
      <span className="text-sm capitalize text-primary-white text-opacity-80 leading-[19.2px]">
        {hours}
      </span>
    </div>
  );
}

export default WorkingHours;
